import { useState, useMemo } from 'react';
import { Tabs, Tab, Box, Card } from '@mui/material';
import PropTypes from 'prop-types';
import InvoiceApproval from './InvoiceApprovals';

InvoiceApprovalTabs.propTypes = {
  isManualFacilityApproverEditor: PropTypes.bool,
  isElectronicFacilityApproverEditor: PropTypes.bool,
  gridSx: PropTypes.object,
  childHeightSx: PropTypes.object,
};
export default function InvoiceApprovalTabs({
  gridSx,
  childHeightSx,
  isManualFacilityApproverEditor,
  isElectronicFacilityApproverEditor,
}) {
  const tabs = useMemo(() => {
    const t = [];

    if (isManualFacilityApproverEditor) {
      t.push({ label: 'Manual', isManual: true });
    }

    if (isElectronicFacilityApproverEditor) {
      t.push({ label: 'Electronic', isManual: false });
    }

    return t;
  }, [isManualFacilityApproverEditor, isElectronicFacilityApproverEditor]);

  const [tab, setTab] = useState(0);

  const handleChange = (_, newValue) => setTab(newValue);

  const activeTab = tabs[tab];

  return (
    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>

      <Box>
        <Tabs value={tab} onChange={handleChange}>
          {tabs.map((t) => (
            <Tab key={t.isManual ? 'manual' : 'electronic'} label={t.label} />
          ))}
        </Tabs>
      </Box>

      {activeTab && (
        <InvoiceApproval
          isManual={activeTab.isManual}
          gridSx={gridSx}
          heightSx={childHeightSx}
        />
      )}

    </Card>
  );
}